import React, { useEffect, useState } from "react";
import "../assets/OnboardLicense.css";
import "../assets/OnboardedSolutionDetails.css";
import { fetchData, postData, postFormData } from "../api/restapi";

function DeltaMBNDetailsTab() {
    const [solutions, setSolutions] = useState([]);

    useEffect(() => {
        fetchData("/qfm/v1/solutions/portal/mbns").then((data) => {
            const mbns = data.mbns.map((mbn) => ({
                ...mbn,
            }));
            setSolutions(mbns || []);
        });
    }, []);

    return (
        <div className="osln-tab-container">
            <div className="tab-heading">
                <h1>Onboarded Delta MBN</h1>
            </div>
            <table className="solutions-table">
                <thead>
                    <tr>
                        {[
                            { key: "mbnFileId", label: "MBN File Id" },
                            { key: "mbnIdHash", label: "MBN Hash" },
                            { key: "description", label: "Description" },
                            { key: "file", label: "File" },
                            { key: "user", label: "Onboarded By" },
                        ].map((col) => (
                            <th key={col.key}>{col.label}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {solutions.map((mbn) => (
                        <tr key={mbn.mbnFileId}>
                            <td>{mbn.mbnFileId}</td>
                            <td>{mbn.mbnIdHash}</td>
                            <td>{mbn.description}</td>
                            <td>{mbn.file}</td>
                            <td>{mbn.user}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default DeltaMBNDetailsTab;
